import{useCallback as o}from"react";function n(...o){return n=>o.forEach((o=>function(o,n){"function"==typeof o?o(n):null!=o&&(o.current=n)}(o,n)))}function e(...e){return o(n(...e),e)}export{n as composeRefs,e as useComposedRefs};
//# sourceMappingURL=index.js.map
